import { required, email, maxLength } from "@vuelidate/validators";

export default {
  email: {
    required,
    emailFormat: email,
    maxLength: maxLength(100),
  },
};
